import { INNER_STATUSES_ENUM } from '@/components/Shared/constants/statuses';

export enum PosCredStatusCodeEnum {
  sms_verificating = 'sms_verificating',
  draft = 'draft',
  waiting_bank_response = 'waiting_bank_response',
  error = 'error',
  declined = 'declined',
  mobile_client = 'mobile_client',
  financed = 'financed',
  approved = 'approved',
  refunded = 'refunded',
  refund_in_progress = 'refund_in_progress'
}

export type PosCredStatusCode = keyof typeof PosCredStatusCodeEnum;

export const BANK_STATUSES = {
  [PosCredStatusCodeEnum.draft]: INNER_STATUSES_ENUM.default,
  [PosCredStatusCodeEnum.sms_verificating]: INNER_STATUSES_ENUM.processing,
  [PosCredStatusCodeEnum.error]: INNER_STATUSES_ENUM.error,
  [PosCredStatusCodeEnum.declined]: INNER_STATUSES_ENUM.error,
  [PosCredStatusCodeEnum.mobile_client]: INNER_STATUSES_ENUM.processing,
  [PosCredStatusCodeEnum.waiting_bank_response]: INNER_STATUSES_ENUM.warning,
  [PosCredStatusCodeEnum.financed]: INNER_STATUSES_ENUM.success,
  [PosCredStatusCodeEnum.approved]: INNER_STATUSES_ENUM.success,
  [PosCredStatusCodeEnum.refunded]: INNER_STATUSES_ENUM.default,
  [PosCredStatusCodeEnum.refund_in_progress]: INNER_STATUSES_ENUM.warning
};

export const POS_CREDIT_BANK_POSITIONS: string[] = [
  PosCredStatusCodeEnum.financed,
  PosCredStatusCodeEnum.refunded,
  PosCredStatusCodeEnum.refund_in_progress,
  PosCredStatusCodeEnum.mobile_client,
  PosCredStatusCodeEnum.approved,
  PosCredStatusCodeEnum.waiting_bank_response,
  PosCredStatusCodeEnum.declined,
  PosCredStatusCodeEnum.error,
  PosCredStatusCodeEnum.draft,
  PosCredStatusCodeEnum.sms_verificating
];
